import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate } from "react-router-dom";
import { PageLoader } from "./page-loader";
import { isAdmin, isDealer } from "../utils/auth.utils";

const RoleBasedGuard = ({ component: Component, requiredRole, ...props }) => {
  const { user, isAuthenticated, isLoading } = useAuth0();

  // Show loading while auth is being checked
  if (isLoading) {
    return <PageLoader />;
  }

  // If not authenticated, redirect to login (handled by withAuthenticationRequired)
  if (!isAuthenticated) {
    const ProtectedComponent = withAuthenticationRequired(Component, {
      onRedirecting: () => <PageLoader />,
    });
    return <ProtectedComponent {...props} />;
  }

  // Check role permissions
  let hasAccess = false;
  if (requiredRole === "admin" && isAdmin(user)) {
    hasAccess = true;
  } else if (requiredRole === "dealer" && isDealer(user)) {
    hasAccess = true;
  }

  // If user doesn't have required role, redirect to access restricted page
  if (!hasAccess) {
    return <Navigate to="/restricted" replace />;
  }

  // User has access, render the component
  return <Component {...props} />;
};

export const AuthenticationGuard = ({ component: Component, ...props }) => {
  const ProtectedComponent = withAuthenticationRequired(Component, {
    onRedirecting: () => <PageLoader />,
  });

  return <ProtectedComponent {...props} />;
};

export { RoleBasedGuard };
